// export const getBotAnalytics = async payload => {
//   const startStr = encodeURIComponent(payload.analyticsStartDate.toISOString());
//   const endStr = encodeURIComponent(payload.analyticsEndDate.toISOString());
//   const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}/analytics?startDate=${startStr}&endDate=${endStr}`;
//   const options = {
//     method: "GET",
//     headers: {
//       Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
//       "x-workspace-id": payload.botODM.omniData.workspaceId,
//     },
//     body: undefined,
//   };

//   try {
//     const response = await fetch(url, options);
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error(error);
//     return Promise.reject(error);
//   }
// };

//this POS function only returns 30 days at a time.
export const getBotAnalytics = async payload => {
  const startStr = encodeURIComponent(payload.analyticsStartDate.toISOString());
  const endStr = encodeURIComponent(payload.analyticsEndDate.toISOString());

  const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}/analytics?startDate=${startStr}&endDate=${endStr}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    const responseArray = { records: data.records };
    // const responseArray = { records: [] };
    // let searchDate = new Date(payload.analyticsStartDate);
    // while (searchDate <= payload.analyticsEndDate) {
    //   const found = data.records.find(d =>
    //     d.startDateTimeUtc.startsWith(format(searchDate, "yyyy-MM-dd")),
    //   );
    //   if (found) {
    //     responseArray.records.push(found);
    //   } else {
    //     const emptyData = {
    //       startDateTimeUtc: searchDate.toISOString(),
    //       endDateTimeUtc: searchDate.toISOString(),
    //       returningUsers: 0,
    //       newUsers: 0,
    //       sessions: 0,
    //       userMessages: 0,
    //       botMessages: 0,
    //       events: 0,
    //       eventTypes: {
    //         "webchat:trigger": 0,
    //         "webchat:conversationStarted": 0,
    //         state_expired: 0,
    //       },
    //       customEvents: {},
    //       llm: {
    //         calls: 0,
    //         errors: 0,
    //         inputTokens: 0,
    //         outputTokens: 0,
    //         latency: {
    //           mean: 0,
    //           sd: 0,
    //           min: 0,
    //           max: 0,
    //         },
    //         tokensPerSecond: {
    //           mean: 0,
    //           sd: 0,
    //           min: 0,
    //           max: 0,
    //         },
    //         cost: {
    //           sum: 0,
    //           mean: 0,
    //           sd: 0,
    //           min: 0,
    //           max: 0,
    //         },
    //       },
    //       messages: 0,
    //     };
    //     responseArray.records.push(emptyData);
    //   }
    //   searchDate.setUTCDate(searchDate.getUTCDate() + 1);
    // }

    return responseArray;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBot = async payload => {
  const url = `https://api.botpress.cloud/v1/admin/bots/${payload.botODM.omniData.botId}`;
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBotpressSummary = async payload => {
  const url = `https://status.botpress.com/api/v2/summary.json`;
  const options = {
    method: "GET",
    headers: {
      // Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      // "x-workspace-id": payload.botODM.omniData.workspaceId,
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchConversations = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ConversationsTable/rows/find";

  try {
    let body = {
      limit: payload.pageSize,
      offset: payload.pageIndex * payload.pageSize,
      // filter: payload.query || {},
      // group: payload.group || {},
      // search: payload.search || "",
      // orderBy: "createdAt", //payload.orderBy || "id  ",
      // orderDirection: "desc",
    };

    if (payload.sort != null) {
      Object.keys(payload.sort).forEach(key => {
        body["orderBy"] = key;
        body["orderDirection"] = payload.sort[key];
      });
    }

    if (payload.query != null) {
      body.filter = payload.query;
    }

    const options = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
        "x-bot-id": payload.botODM.omniData.botId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteConversation = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ConversationsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: [payload.conversationId] }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchFeedback = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/FeedbackTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
    // filter: payload.query || {},
    // group: payload.group || {},
    // search: payload.search || "",
    // orderBy: "createdAt", //payload.orderBy || "id  ",
    // orderDirection: "desc",
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.feedbackIDs }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.feedbackRecords, waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateChat = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ConversationsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.chatRecords, waitComputed: true }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addFeedback = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/FeedbackTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: payload.feedbackRecords, waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#region assessments

export const searchAssessment = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
    // filter: payload.query || {},
    // group: payload.group || {},
    // search: payload.search || "",
    // orderBy: "createdAt", //payload.orderBy || "id  ",
    // orderDirection: "desc",
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteAssessments = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.assessmentIDs }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateAssessment = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.assessmentRecord], waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addAssessment = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/AssessmentsTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.assessmentRecord], waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region products

export const searchProducts = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ProductsTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
    // filter: payload.query || {},
    // group: payload.group || {},
    // search: payload.search || "",
    // orderBy: "createdAt", //payload.orderBy || "id  ",
    // orderDirection: "desc",
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteProducts = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows/delete`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: payload.productIDs }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateProduct = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows/upsert`;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.productRecord], waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addProduct = async payload => {
  const url = `https://api.botpress.cloud/v1/tables/ProductsTable/rows`;

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows: [payload.productRecord], waitComputed: true }),
  };
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//#endregion

//#region files

export const listBotpressFiles = async payload => {
  const params = new URLSearchParams();

  if (payload.nextToken != null) {
    params.append("nextToken", payload.nextToken);
  }

  if (payload.indexed != null) {
    params.append("indexed", payload.indexed);
  }

  const queryString = params.toString();
  const url = `https://api.botpress.cloud/v1/files${queryString ? `?${queryString}` : ""}`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const listAllBotpressFiles = async payload => {
  let allFiles = [];
  let nextToken = null;
  let lastToken = null;

  do {
    lastToken = nextToken;

    const data = await listBotpressFiles({
      ...payload,
      nextToken,
      indexed: payload.indexed ?? true,
    });

    allFiles = allFiles.concat(data.files || []);
    nextToken = data.meta?.nextToken ? data.meta.nextToken : null;
  } while (nextToken != null && nextToken !== lastToken);

  return allFiles;
};

export const listBotpressFilePassages = async payload => {
  const params = new URLSearchParams();

  if (payload.nextToken != null) {
    params.append("nextToken", payload.nextToken);
  }

  if (payload.limit != null) {
    params.append("limit", payload.limit);
  }

  const queryString = params.toString();
  const url = `https://api.botpress.cloud/v1/files/${payload.fileId}/passages${
    queryString ? `?${queryString}` : ""
  }`;

  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: undefined,
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const listAllBotpressFilePassages = async payload => {
  let allPassages = [];
  let nextToken = null;
  let lastToken = null;

  do {
    lastToken = nextToken;

    const data = await listBotpressFilePassages({
      ...payload,
      nextToken,
      limit: payload.limit ?? 200,
    });

    allPassages = allPassages.concat(data.passages || []);
    nextToken = data.meta?.nextToken ? data.meta.nextToken : null;
  } while (nextToken != null && nextToken !== lastToken);

  return allPassages;
};

export const getBotpressScrapedWebsiteUrls = async payload => {
  const files = await listAllBotpressFiles({
    ...payload,
    indexed: true,
  });

  let scrapedWebsiteUrls = [];

  const isValidWebsiteUrl = url => {
    if (url == null || url === "") {
      return false;
    }

    if (url.includes("amazonaws.com")) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
    } catch (error) {
      return false;
    }
  };

  for (const file of files) {
    const passages = await listAllBotpressFilePassages({
      ...payload,
      fileId: file.id,
    });

    const passageUrls = passages
      .flatMap(passage => [
        passage.meta?.sourceUrl,
        passage.meta?.url,
        passage.meta?.pageUrl,
        passage.meta?.websiteUrl,
        passage.meta?.webpageUrl,
        passage.meta?.documentUrl,
        passage.metadata?.sourceUrl,
        passage.metadata?.url,
        passage.metadata?.pageUrl,
        passage.metadata?.websiteUrl,
        passage.metadata?.webpageUrl,
        passage.metadata?.documentUrl,
      ])
      .filter(isValidWebsiteUrl);

    const fileUrls = [
      file.metadata?.sourceUrl,
      file.metadata?.url,
      file.metadata?.pageUrl,
      file.metadata?.websiteUrl,
      file.metadata?.webpageUrl,
      file.metadata?.documentUrl,
      ...passageUrls,
    ].filter(isValidWebsiteUrl);

    const uniqueUrls = [...new Set(fileUrls)];

    if (uniqueUrls.length > 0) {
      scrapedWebsiteUrls.push({
        fileId: file.id,
        key: file.key,
        contentType: file.contentType,
        tags: file.tags,
        metadata: file.metadata,
        createdAt: file.createdAt,
        updatedAt: file.updatedAt,
        scrapedUrls: uniqueUrls,
      });
    }
  }

  return scrapedWebsiteUrls;
};

export const getBotpressMarkdownFiles = async payload => {
  const files = await listAllBotpressFiles({
    ...payload,
    indexed: true,
  });

  const isMarkdownFile = file => {
    const key = file.key || "";
    const name = file.name || "";
    const fileName = file.fileName || "";
    const contentType = file.contentType || "";
    const metadataFileName =
      file.metadata?.fileName ||
      file.metadata?.filename ||
      file.metadata?.name ||
      file.metadata?.sourceFile ||
      "";

    return (
      key.toLowerCase().endsWith(".md") ||
      name.toLowerCase().endsWith(".md") ||
      fileName.toLowerCase().endsWith(".md") ||
      metadataFileName.toLowerCase().endsWith(".md") ||
      key.toLowerCase().endsWith(".markdown") ||
      name.toLowerCase().endsWith(".markdown") ||
      fileName.toLowerCase().endsWith(".markdown") ||
      metadataFileName.toLowerCase().endsWith(".markdown") ||
      contentType === "text/markdown" ||
      contentType === "text/x-markdown"
    );
  };

  const getPassageContent = passage => {
    return (
      passage.content ||
      passage.text ||
      passage.value ||
      passage.chunk ||
      passage.pageContent ||
      passage.data?.content ||
      passage.data?.text ||
      ""
    );
  };

  const markdownFiles = [];

  for (const file of files.filter(isMarkdownFile)) {
    const passages = await listAllBotpressFilePassages({
      ...payload,
      fileId: file.id,
    });

    const content = passages.map(getPassageContent).filter(Boolean).join("\n");

    markdownFiles.push({
      id: file.id,
      name:
        file.key ||
        file.name ||
        file.fileName ||
        file.metadata?.fileName ||
        file.metadata?.filename ||
        file.id,
      fileName:
        file.key ||
        file.name ||
        file.fileName ||
        file.metadata?.fileName ||
        file.metadata?.filename ||
        file.id,
      key: file.key,
      contentType: file.contentType,
      tags: file.tags,
      metadata: file.metadata,
      createdAt: file.createdAt,
      updatedAt: file.updatedAt,
      content,
      passages,
    });
  }

  return markdownFiles;
};

//#endregion

export const loadConversation = async payload => {
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
    },
  };

  const url = `https://api.botpress.cloud/v1/chat/messages?conversationId=${payload.conversationId}`;

  try {
    let nextToken = null;
    let lastToken = null;
    let allMessages = [];
    let theResult = null;
    do {
      let builtURL = url;
      lastToken = nextToken;
      if (nextToken != null) {
        builtURL = url + `&nextToken=${nextToken}`;
      }
      const response = await fetch(builtURL, options);
      theResult = await response.json();
      lastToken = nextToken;
      nextToken = theResult.meta?.nextToken ? theResult.meta?.nextToken : null;
      allMessages = allMessages.concat(theResult.messages);
    } while (nextToken != null && nextToken !== lastToken);

    return allMessages;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createUser = async payload => {
  const options = {
    method: "POST",
    headers: {
      // Authorization: `Bearer ${payload.omniData.accessToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: "AKTest",
    }),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/users`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

//Create Conversation
export const createConversation = async payload => {
  const options = {
    method: "POST",
    headers: {
      "x-user-key": payload.key,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: "" }),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/conversations`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// Send Message
export const sendMessage = async payload => {
  const options = {
    method: "POST",
    headers: {
      "x-user-key": payload.key,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: "" }),
  };

  const url = `https://chat.botpress.cloud/${payload.botODM.omniData.webchatClientId}/messages`;

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const searchConfiguration = async payload => {
  const url = "https://api.botpress.cloud/v1/tables/ConfigurationTable/rows/find";

  let body = {
    limit: payload.pageSize,
    offset: payload.pageIndex * payload.pageSize,
    // filter: payload.query || {},
    // group: payload.group || {},
    // search: payload.search || "",
    // orderBy: "createdAt", //payload.orderBy || "id  ",
    // orderDirection: "desc",
  };

  if (payload.sort != null) {
    Object.keys(payload.sort).forEach(key => {
      body["orderBy"] = key;
      body["orderDirection"] = payload.sort[key];
    });
  }

  if (payload.query != null) {
    body.filter = payload.query;
  }

  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${payload.botODM.omniData.accessToken}`,
      "x-bot-id": payload.botODM.omniData.botId,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
